import React, { useState, useEffect } from 'react'
import { FormControl, InputLabel, styled, useTheme, Box } from '@mui/material'
import MUIDatePicker from 'packages/eid-ui/DateTimePickers/MUIDateTimePicker/MUIDatePicker'

const StyledFormControl = styled(FormControl)({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
})

const StyledInputLabel = styled(InputLabel)({
    textTransform: 'uppercase',
    color: '#73767A',
    paddingLeft: '1.6rem',
})

const DatePickerFilter = ({ value, onChange, placeholder, label, ...rest }) => {
    const theme = useTheme()
    const [dateValue, setDateValue] = useState(value || null)

    useEffect(() => {
        if (value !== dateValue) {
            setDateValue(value || null)
        }
    }, [value])

    const handleDateChange = (momentValue) => {
        // Convert moment to ISO string or null
        const newValue = momentValue ? momentValue.toISOString() : null
        setDateValue(newValue)
        onChange(newValue || '')
    }

    return (
        <StyledFormControl variant="standard">
            {label && (
                <StyledInputLabel
                    shrink
                    fontSize="1.6rem"
                    style={{ fontSize: '1.6rem' }}
                >
                    {label}
                </StyledInputLabel>
            )}
            <Box
                sx={{
                    width: '100%',
                    'label + &': {
                        marginTop: theme.spacing(3),
                    },
                }}
            >
                <MUIDatePicker
                    value={dateValue}
                    handleChange={handleDateChange}
                    label=""
                    placeholder={placeholder}
                    fieldProps={{
                        variant: 'standard',
                        placeholder: placeholder,
                        sx: {
                            width: '100%',
                            '& .MuiInputBase-root': {
                                borderRadius: '0.4rem',
                                position: 'relative',
                                backgroundColor: '#ffffff !important',
                                border: 'solid 0.1rem #ebebed',
                                fontSize: '1.6rem',
                                padding: '1rem 1.2rem',
                                boxShadow:
                                    '0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
                                transition:
                                    'border 0.15s ease-in-out 0s, background 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                                '&:focus-within': {
                                    boxShadow: `0 0.2rem 0.4rem 0 ${theme.palette.primary.light}`,
                                    borderColor: theme.palette.primary.main,
                                    backgroundColor: theme.palette.common.white,
                                },
                                '&:hover': {
                                    borderColor: theme.palette.primary.main,
                                },
                                '&::before': {
                                    display: 'none',
                                },
                                '&::after': {
                                    display: 'none',
                                },
                            },
                            '& .MuiInputBase-input': {
                                height: '1.8rem',
                                fontSize: '1.6rem',
                                padding: 0,
                                '&::placeholder': {
                                    opacity: 1,
                                    color: '#b4b4b4',
                                },
                                '&::-webkit-input-placeholder': {
                                    opacity: 1,
                                    color: '#b4b4b4',
                                },
                                '&::-moz-placeholder': {
                                    opacity: 1,
                                    color: '#b4b4b4',
                                },
                                '&:-ms-input-placeholder': {
                                    opacity: 1,
                                    color: '#b4b4b4',
                                },
                            },
                        },
                    }}
                    {...rest}
                />
            </Box>
        </StyledFormControl>
    )
}

export default DatePickerFilter
